import type { Dayjs } from "dayjs";
import {
  PALOMMA_PAYMENTS,
  datedDeadlines,
  palommaPaymentDate,
} from "./deadlines";

const SUFFIX = " · Palomma Protect";

const icsEvent = (
  id: string,
  date: Dayjs,
  summary: string,
  stamp: string
): string[] => [
  "BEGIN:VEVENT",
  `UID:${id}-${date.format("YYYYMMDD")}@palomma-protect`,
  `DTSTAMP:${stamp}`,
  `DTSTART;VALUE=DATE:${date.format("YYYYMMDD")}`,
  `SUMMARY:${summary}${SUFFIX}`,
  "END:VEVENT",
];

export const buildMonthIcs = (month: Dayjs, now: Dayjs): string => {
  const stamp = now.utc().format("YYYYMMDD[T]HHmmss[Z]");
  const paymentDate = palommaPaymentDate(month);

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Palomma Protect//Calendario Operativo//ES",
    "CALSCALE:GREGORIAN",
    ...datedDeadlines(month).flatMap((deadline) =>
      icsEvent(deadline.id, deadline.date, deadline.title, stamp)
    ),
    ...PALOMMA_PAYMENTS.flatMap((payment) =>
      icsEvent(payment.id, paymentDate, payment.description, stamp)
    ),
    "END:VCALENDAR",
  ].join("\r\n");
};

export const downloadMonthIcs = (month: Dayjs, now: Dayjs): void => {
  const blob = new Blob([buildMonthIcs(month, now)], {
    type: "text/calendar;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Palomma_Protect_${month.format("YYYY-MM")}.ics`;
  link.click();
  URL.revokeObjectURL(url);
};
